import http from '@/services/http';
import { downloadPkpass } from '@/helpers/download-apple-wallet-pass';



export const downloadOrderRedemptionAppleWalletPass = async (params) => {
  try {
    const requiredParams = ['oi', 'tn', 'rt', 'ldt', 'lt', 'lg'];
    const missingParams = requiredParams.filter(key => params[key] === undefined);

    if (missingParams.length) {
      throw new Error(`Missing query params: ${missingParams.join(', ')}`);
    }

    const { data } = await http.get(
      '/cardfree-api/v1/wallet/apple',
      {
        params,
        responseType: 'arraybuffer',
        headers: { accept: 'application/vnd.apple.pkpass' }
      }
    );

    downloadPkpass(data, params.rt);
  }
  catch (error) {
    throw error;
  }
};



export default {
  downloadOrderRedemptionAppleWalletPass
};
